<!--
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-04-28 14:02:57
 * @FilePath: \eva-fe\src\app\sourcingFlow\views\supplierComplianceInspection\supplierComplianceInspectionWZ.vue
 * @Description: 供应商符合性检查
-->
<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <template v-if="labelShow">
        <!--      <div class="detail-info-el-Label">-->
        <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
        <!--      </div>-->
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div style="position:relative">
            <div class="ccui-tab-wrapper" style="margin-top:20px">
              <el-button type="table-top-active" size="mini"
                >1、供应商风险排查</el-button
              >
              <div class="searchSup" v-if="billStatus != 1">
                请点击右侧按钮查询投标供应商关联关系
                <el-button
                  plain
                  type="single-number-filleted"
                  @click="companyDetail"
                  >供应商关联关系查询</el-button
                >
              </div>

              <el-button
                type="single-number"
                v-preventReClick
                @click="goTo"
                style="position: absolute;right: 125px;"
                >全国企业采购交易寻源询价系统</el-button
              >
              <el-button
                class="sure-btn"
                v-preventReClick
                v-if="expertRole === '1' && billStatus !== '1'"
                icon="icon-ccui-agree"
                style="position: absolute;right: 0;"
                @click="dealSupComCheckSave('2')"
                >提交确认</el-button
              >
            </div>
            <div class="group-btn-fuhe" v-if="isNewTable">
              <el-table
                class="dic-sub-table-style01"
                :data="tableDataFX"
                border
                style="width: 100%"
              >
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="riskType" label="风险类型" width="180">
                  <template slot-scope="scope">
                    {{
                      scope.row.riskType == 0
                        ? "人员重复"
                        : scope.row.riskType == 1
                        ? "IP重复"
                        : "关联关系"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="hasRisk" label="是否存在" width="180">
                  <template slot-scope="scope">
                    <span
                      :style="{ color: scope.row.hasRisk != 0 ? 'red' : '' }"
                      >{{ scope.row.hasRisk == 0 ? "否" : "是" }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="riskDesc"
                  label="详情描述"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                  prop="riskCheck"
                  width="180"
                  label="方案是否存在问题"
                >
                  <template slot="header">
                    <template>
                      <span class="star">*</span>
                      <span>方案是否存在问题</span>
                    </template>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.riskCheck"
                      :disabled="disabled"
                    >
                      <el-option value="0" label="无问题"></el-option>
                      <el-option value="1" label="有问题"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="reason" width="180" label="理由">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.reason"
                      maxlength="100"
                      :disabled="disabled"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="group-btn-fuhe" v-else>
              <span style="color:red;margin-right:10px">*</span>
              <el-checkbox
                v-model="checked"
                :disabled="disabled || expertRole === '0' || expertRole === '2'"
                @change="checkedChange"
                >已排查供应商关联关系，董高监等围标串标嫌疑</el-checkbox
              >
              <div class="btn-radio-right">
                <span style="color:red;margin-right:10px">*</span>
                <el-radio
                  v-model="radio"
                  label="0"
                  @change="radioChange"
                  :disabled="
                    disabled || expertRole === '0' || expertRole === '2'
                  "
                  >无问题</el-radio
                >
                <el-radio
                  v-model="radio"
                  label="1"
                  @change="radioChange"
                  :disabled="
                    disabled || expertRole === '0' || expertRole === '2'
                  "
                  >有问题已检查处理</el-radio
                >
              </div>
            </div>
          </div>
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >2、供应商符合性检查结果<span
                  style="color:#FF142F"
                  v-if="expertRole === '0' || expertRole === '2'"
                  >{{ "（状态：" + breadcrumbData.status + "）" }}</span
                ></el-button
              >
              <div style="margin-top: 15px;">
                <el-radio-group
                  v-model="activeName"
                  size="small"
                  @change="handleClick"
                >
                  <el-radio-button
                    label="AI符合性检查结果"
                    v-if="aiReviewFlag == 1"
                  ></el-radio-button>
                  <el-radio-button
                    label="专家确认符合性检查结果"
                  ></el-radio-button>
                </el-radio-group>
                <span
                  v-if="aiReviewFlag == 1"
                  style="display: inline-block; margin-left: 10px; color: #F56C6C;"
                  >提示：此处符合性审查结果带出AI审查结果，若需修改符合性审查结果需通过AI符合性审查结果页签进行修改</span
                >
              </div>
            </div>
            <el-button
              v-if="billStatus === '1'"
              type="single-number"
              v-preventReClick
              @click="exportPdf"
              style="float:right"
              >导出</el-button
            >
          </div>
          <div
            @click.prevent="confirmBtn('0')"
            style="display: inline-block;margin-right: 30px"
          >
            <el-radio
              v-model="radio1"
              label="0"
              border
              v-if="
                supComCheckConfirmDetail.confirmStatus === '0' &&
                  (expertRole === '0' || expertRole === '2') &&
                  billStatus !== '1'
              "
              >同意</el-radio
            >
            <!-- @click="dealSupComCheckConfirm('0')" -->
          </div>
          <div @click.prevent="confirmBtn('1')" style="display: inline-block">
            <el-radio
              v-model="radio1"
              label="1"
              border
              v-if="
                supComCheckConfirmDetail.confirmStatus === '0' &&
                  (expertRole === '0' || expertRole === '2') &&
                  billStatus !== '1'
              "
              >不同意</el-radio
            >
            <!-- @click="dealSupComCheckConfirm('1')" -->
          </div>
          <template
            v-if="
              supComCheckConfirmDetail.confirmStatus === '0' &&
                (expertRole === '0' || expertRole === '2') &&
                billStatus !== '1'
            "
          >
            <div class="ccui-tab-iframe">
              <div class="ccui-tab-wrapper">
                <el-button type="table-top-active" size="mini"
                  ><span style="color:red">*</span>3、确认意见<span
                    style="color:#FF142F"
                    >（第{{ this.roudMax }}轮确认）</span
                  ></el-button
                >
              </div>
            </div>
            <el-form
              :model="supComCheckConfirm"
              label-width="120px"
              label-position="top"
            >
              <el-form-item label="">
                <el-input
                  maxlength="1000"
                  show-word-limit
                  type="textarea"
                  @change="confirmOpinionChange"
                  v-model="supComCheckConfirm.confirmOpinion"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
          <template v-if="activeName === '专家确认符合性检查结果'">
            <div
              v-if="
                (subPackageFlag && (expertRole == 0 || expertRole == 2)) ||
                  (subPackageFlag && expertRole == 1)
              "
            >
              <div v-for="(items, index) in rowData" :key="index">
                <div class="packBox">
                  <p class="packNameBox">
                    包件名称 :{{ items.packName }}
                    <span
                      style="color:red"
                      v-if="items.packStatus == 2 || items.packStatus == 5"
                      >（已流标）</span
                    >
                  </p>
                </div>
                <el-table
                  :data="items.sscSupComPriceBOS"
                  border
                  class="dic-sub-table-style01 word-wrap-fhjc"
                >
                  <el-table-column width="50" label="序号" type="index">
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index) in confirmCheckColumns"
                    :key="index"
                    :show-overflow-tooltip="true"
                    v-bind="item"
                  >
                    <template slot="header">
                      <template v-if="item.required">
                        <span class="star">*</span>
                        <span>{{ item.label }}</span>
                      </template>
                      <template v-else>{{ item.label }}</template>
                    </template>
                    <template slot-scope="scope">
                      <el-select
                        v-if="item.type == 'select' && expertRole === '1'"
                        :disabled="
                          scope.row.disabled ||
                            items.packStatus == 2 ||
                            items.packStatus == 5
                        "
                        v-model.trim="scope.row[item.prop]"
                        @change="changeLostFlag(scope.row, scope.$index)"
                      >
                        <el-option value="0" label="通过"></el-option>
                        <el-option value="1" label="不通过"></el-option>
                      </el-select>
                      <span
                        v-else-if="
                          item.type == 'select' &&
                            billStatus === '0' &&
                            expertRole === '0'
                        "
                      >
                        {{ scope.row[item.prop] == "0" ? "通过" : "不通过" }}
                      </span>
                      <el-input
                        v-else-if="
                          item.type == 'input' &&
                            expertRole === '1' &&
                            !disabled
                        "
                        :disabled="
                          items.packStatus == 2 || items.packStatus == 5
                        "
                        v-model.trim="scope.row[item.prop]"
                        maxlength="1000"
                        show-word-limit
                        class="input-short word-limit input-width;"
                        placeholder="请输入"
                        @change="handleInput(scope.row, scope.$index)"
                      />
                      <el-button
                        v-else-if="item.type == 'link'"
                        size="mini"
                        type="text"
                        @click="viewBidFile(scope.row)"
                        >查看投标文件</el-button
                      >
                      <span v-else-if="item.money">{{
                        scope.row[item.prop]
                          ? new BigNumber(scope.row[item.prop]).toFormat(2)
                          : ""
                      }}</span>
                      <el-button
                        v-else-if="
                          item.prop == 'aiReviewStatusStr' &&
                            billStatus !== '1' &&
                            expertRole == 1
                        "
                        size="mini"
                        type="text"
                        @click="handleGoAi(scope.row)"
                      >
                        {{ scope.row[item.prop] }}</el-button
                      >
                      <span v-else>{{
                        item.prop == "passFlag"
                          ? scope.row.passFlagStr
                          : scope.row[item.prop]
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="AI审查状态"
                    prop="anaProgressStr"
                    width="120"
                    v-if="aiReviewFlag == 1"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <el-table
              :data="tableData"
              border
              v-else-if="expertRole == 0 || expertRole == 1 || expertRole == 2"
              class="dic-sub-table-style01"
            >
              <el-table-column
                type="index"
                width="50"
                label="序号"
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in confirmCheckColumns2"
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
              >
                <template slot="header">
                  <template v-if="item.required">
                    <span class="star">*</span>
                    <span>{{ item.label }}</span>
                  </template>
                  <template v-else>{{ item.label }}</template>
                </template>
                <template slot-scope="scope">
                  <el-select
                    v-if="
                      item.type == 'select' &&
                        (billStatus === '0' || billStatus === '2') &&
                        expertRole === '1'
                    "
                    :disabled="
                      scope.row.disabled ||
                        scope.row.packStatus == 2 ||
                        scope.row.packStatus == 5
                    "
                    v-model.trim="scope.row[item.prop]"
                    @change="changeLostFlag(scope.row, scope.$index)"
                  >
                    <el-option value="0" label="通过"></el-option>
                    <el-option value="1" label="不通过"></el-option>
                  </el-select>
                  <span
                    v-else-if="
                      item.type == 'select' &&
                        billStatus === '0' &&
                        expertRole === '0'
                    "
                  >
                    {{ scope.row[item.prop] == "0" ? "通过" : "不通过" }}
                  </span>
                  <el-input
                    v-else-if="
                      item.type == 'input' &&
                        (billStatus === '0' || billStatus === '2') &&
                        expertRole === '1' &&
                        !disabled
                    "
                    :disabled="
                      scope.row.packStatus == 2 || scope.row.packStatus == 5
                    "
                    v-model.trim="scope.row[item.prop]"
                    maxlength="1000"
                    show-word-limit
                    class="input-short word-limit input-width;"
                    placeholder="请输入"
                    @change="handleInput(scope.row, scope.$index)"
                  />
                  <el-button
                    v-else-if="item.type == 'link'"
                    size="mini"
                    type="text"
                    @click="viewBidFile(scope.row)"
                    >查看投标文件</el-button
                  >
                  <span v-else-if="item.money">{{
                    scope.row[item.prop]
                      ? new BigNumber(scope.row[item.prop]).toFormat(2)
                      : ""
                  }}</span>
                  <span v-else-if="item.prop == 'packName'">
                    {{ scope.row[item.prop]
                    }}<span
                      v-if="
                        scope.row.packStatus == 2 || scope.row.packStatus == 5
                      "
                      style="color:red"
                      >（已流标）</span
                    >
                  </span>
                  <span v-else>{{
                    item.prop == "passFlag"
                      ? scope.row.passFlagStr
                      : scope.row[item.prop]
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="AI审查状态"
                prop="anaProgressStr"
                width="120"
                v-if="aiReviewFlag == 1"
              >
              </el-table-column>
            </el-table>
          </template>
          <template v-if="activeName === 'AI符合性检查结果'">
            <div
              v-if="
                (subPackageFlag && (expertRole == 0 || expertRole == 2)) ||
                  (subPackageFlag && expertRole == 1)
              "
            >
              <template v-if="rowDataAI.length > 0">
                <div v-for="(items, index) in rowDataAI" :key="index">
                  <div class="packBox">
                    <p class="packNameBox">
                      包件名称 :{{ items.packName }}
                      <span
                        style="color:red"
                        v-if="items.packStatus == 2 || items.packStatus == 5"
                        >（已流标）</span
                      >
                    </p>
                  </div>
                  <el-table
                    :data="items.list"
                    border
                    class="dic-sub-table-style01"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      v-for="(item, index) in items.confirmCheckColumns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                      :class-name="
                        activeColumns[items.packId] === item.prop
                          ? 'active-column'
                          : ''
                      "
                    >
                      <!-- <template slot="header">
                  <template v-if="item.required">
                    <span class="star">*</span>
                    <span>{{ item.label }}</span>
                  </template>
                  <template v-else>{{ item.label }}</template>
                </template> -->
                      <template slot-scope="scope">
                        <span
                          v-if="item.prop != 'supName'"
                          @click="
                            handleClickReq(scope.row, scope.$index, item.prop)
                          "
                          :style="{
                            cursor:
                              item.prop === 'finalResult'
                                ? 'default'
                                : 'pointer'
                          }"
                        >
                          <span v-if="scope.row[item.prop] == 1">
                            <el-tag type="success" size="small" effect="plain">
                              通过
                            </el-tag>
                          </span>
                          <span v-else>
                            <el-tag type="danger" size="small" effect="plain">
                              不通过
                            </el-tag>
                          </span>
                          <!-- {{ scope.row[item.prop] == "0" ? "通过" : "不通过" }} -->
                        </span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="margin: 20px 0;">
                    <el-table
                      :data="items.tableDataAIReq"
                      border
                      :key="rowKey"
                      :span-method="
                        data =>
                          objectSpanMethodPickAIReq(data, items.tableDataAIReq)
                      "
                      empty-text="在上方表格选定查看项后，当前表格将自动呈现相关对应内容。"
                      class="dic-sub-table-style01"
                    >
                      <el-table-column
                        type="index"
                        width="50"
                        label="序号"
                      ></el-table-column>
                      <el-table-column
                        v-for="(item, index) in confirmCheckColumns4"
                        :key="index"
                        class-name="address-cell"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                      >
                        <template slot="header">
                          <!-- 分包情况下，如果是评审项目列，使用当前包件的 currentReviewItemLabel -->
                          <span
                            v-if="
                              item.prop === 'reviewItemName' &&
                                items.currentReviewItemLabel
                            "
                          >
                            {{ items.currentReviewItemLabel }}
                          </span>
                          <span v-else>
                            {{ item.label }}
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <div
                            v-if="item.prop == 'isConformityReason'"
                            @click="handleGoAi(scope.row)"
                            class="linkBox"
                          >
                            {{ scope.row.isConformityReason }}
                          </div>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="200"
                        label="专家说明"
                        prop="expertFixDesc"
                      >
                        <template slot-scope="scope">
                          <el-input
                            v-model.trim="scope.row.expertFixDesc"
                            :disabled="disabled"
                            maxlength="500"
                            placeholder="请输入"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="150"
                        label="操作"
                        prop="modifyIsConformity"
                      >
                        <template slot-scope="scope">
                          <el-select
                            :disabled="disabled"
                            v-model.trim="scope.row.modifyIsConformity"
                            @change="handleChangePickIsConformity"
                          >
                            <el-option value="0" label="不通过"></el-option>
                            <el-option value="1" label="通过"></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="noneDataBox">
                  暂无数据
                </div>
              </template>
            </div>
            <!-- 不分包件 -->
            <div
              v-else-if="expertRole == 0 || expertRole == 1 || expertRole == 2"
            >
              <template v-if="tableDataAI.length > 0">
                <el-table
                  :data="tableDataAI"
                  border
                  class="dic-sub-table-style01"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    v-for="(item, index) in confirmCheckColumns3"
                    :key="index"
                    :show-overflow-tooltip="true"
                    v-bind="item"
                    :class-name="
                      currentColumnProp === item.prop ? 'active-column' : ''
                    "
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="item.prop != 'supName'"
                        @click="
                          handleClickReq(scope.row, scope.$index, item.prop)
                        "
                        :style="{
                          cursor:
                            item.prop === 'finalResult' ? 'default' : 'pointer'
                        }"
                      >
                        <span v-if="scope.row[item.prop] == 1">
                          <el-tag type="success" size="small" effect="plain">
                            通过
                          </el-tag>
                        </span>
                        <span v-else>
                          <el-tag type="danger" size="small" effect="plain">
                            不通过
                          </el-tag>
                        </span>
                        <!-- {{ scope.row[item.prop] == "0" ? "通过" : "不通过" }} -->
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <template v-else>
                <div class="noneDataBox">
                  暂无数据
                </div>
              </template>
              <div style="margin: 20px 0;">
                <el-table
                  :data="tableDataAIReq"
                  border
                  :span-method="objectSpanMethodAIReq"
                  empty-text="在上方表格选定查看项后，当前表格将自动呈现相关对应内容。"
                  class="dic-sub-table-style01"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    v-for="(item, index) in confirmCheckColumns4"
                    :key="index"
                    class-name="address-cell"
                    :show-overflow-tooltip="true"
                    v-bind="item"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="item.prop == 'isConformityReason'"
                        @click="handleGoAi(scope.row)"
                        class="linkBox"
                      >
                        {{ scope.row.isConformityReason }}
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="200"
                    label="专家说明"
                    prop="expertFixDesc"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model.trim="scope.row.expertFixDesc"
                        :disabled="disabled"
                        maxlength="500"
                        placeholder="请输入"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="150"
                    label="操作"
                    prop="modifyIsConformity"
                  >
                    <template slot-scope="scope">
                      <el-select
                        :disabled="disabled"
                        v-model.trim="scope.row.modifyIsConformity"
                        @change="handleChangeIsConformity"
                      >
                        <el-option value="0" label="不通过"></el-option>
                        <el-option value="1" label="通过"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </template>
          <!--      确认中-->
          <template v-if="expertConfirmtableData.length != 0">
            <div class="ccui-tab-iframe">
              <div class="ccui-tab-wrapper">
                <el-button type="table-top-active" size="mini"
                  >专家确认列表</el-button
                >
              </div>
            </div>
            <el-table
              :data="expertConfirmtableData"
              border
              :span-method="objectSpanMethodResult"
              class="dic-sub-table-style01"
            >
              <el-table-column
                v-for="(item, index) in expertColumns"
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
              ></el-table-column>
            </el-table>
          </template>
          <div
            class="ccui-tab-iframe"
            style="position: relative"
            v-if="expertRole == 0 || expertRole == 1 || expertRole == 2"
          >
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >附件信息</el-button
              >
              <upLoadFile
                ref="attachmentUpload"
                :fileData="fileData"
                :type="
                  disabled || expertRole === '0' || expertRole === '2' ? 2 : 0
                "
              ></upLoadFile>
            </div>
          </div>
        </div>
      </div>
      <div class="operate">
        <!--      组长按钮-->
        <template v-if="expertRole === '1'">
          <!--      编辑中-->

          <template v-if="billStatus !== '1' && disabled">
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-edit"
              @click="edit"
              >编辑</el-button
            >
          </template>
          <template v-if="billStatus !== '1'">
            <el-button
              v-if="!disabled"
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('1')"
              >保存</el-button
            >
            <!-- <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('2')"
              >提交确认</el-button
            > -->
          </template>
          <!--      确认中-->

          <template v-if="billStatus === '2'">
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-agree"
              @click="dealSupComCheckEffect"
              >符合性检查生效</el-button
            >
          </template>
        </template>
        <!--<template v-if="billStatus === '1'">-->
        <!--<el-button type="text" icon="icon-ccui-download" @click="exportPdf"-->
        <!--&gt;导出</el-button-->
        <!--&gt;-->
        <!--</template>-->
        <!-- 非组长组员才能点击的按钮 -->
        <!--<template-->
        <!--v-if="-->
        <!--supComCheckConfirmDetail.confirmStatus === '0' &&-->
        <!--expertRole === '0' &&-->
        <!--billStatus !== '1'-->
        <!--"-->
        <!--&gt;-->
        <!--<el-button-->
        <!--type="text"-->
        <!--icon="icon-ccui-save"-->
        <!--v-preventReClick-->
        <!--@click="dealSupComCheckConfirm('1')"-->
        <!--&gt;同意</el-button-->
        <!--&gt;-->
        <!--<el-button-->
        <!--type="text"-->
        <!--icon="icon-ccui-save"-->
        <!--v-preventReClick-->
        <!--@click="dealSupComCheckConfirm('0')"-->
        <!--&gt;不同意</el-button-->
        <!--&gt;-->
        <!--</template>-->
        <el-button type="text" icon="icon-ccui-sharing-o" @click="init"
          >刷新</el-button
        >
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        title=""
        width="1200px"
        v-if="dialogVisible"
      >
        <supplierBidDetails
          :supQuoteId="formData.supQuoteId"
          :supPackQuoteId="formData.supPackQuoteId"
          :supCode="formData.supCode"
          :purchaseType="purchaseType"
          :templateType="templateType"
        ></supplierBidDetails>
        <div slot="footer">
          <el-button
            size="mini"
            type="default-mini"
            @click="dialogVisible = false"
            >取消</el-button
          >
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="dialogVisible = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :title="'AI符合性审查'"
        :visible.sync="dialogVisibles"
        width="1200px"
        height="70vh"
        class="yujing"
      >
        <iframe
          :src="reportUrl"
          frameborder="0"
          height="100%"
          width="100%"
        ></iframe>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            type="default-mini"
            @click="dialogVisibles = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qrySupComCheckListApi,
  dealSupComCheckSaveApi,
  qrySupComCheckConfirmListApi,
  dealSupComCheckConfirmApi,
  dealSupComCheckEffectApi,
  qrySupComCheckConfirmDetailApi,
  qryBidEvaProcessStatusApi,
  supComCheckDetailMobilePdfExport,
  listPurchaseSchemePackageApi,
  SupComRelationCheckSave,
  SupComRelationCheck,
  companyDetail,
  qryBidPricePrepareApi,
  querySupComRelationCheckNew,
  querySupAiReviewList,
  dealSupComRelationCheckSaveNew
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import { commonTableWidth } from "@/setting/setting.js";
import upLoadFile from "@/basa/components/common/attachmentUpload";
export default {
  name: "supplierComplianceInspection",
  components: {
    supplierBidDetails,
    breadcrumbSourcing,
    upLoadFile
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      activeColumns: {}, // 存储每个包件的活动列，格式：{ [packId]: prop }
      timestamp: new Date("2026-03-31T21:00:00").getTime(),
      dialogVisibles: false,
      reportUrl: "",
      activeName: "AI符合性检查结果",
      templateType: "",
      BigNumber: BigNumber,
      checked: false,
      radio: "",
      radio1: "",
      disabled: true,
      breadcrumbData: {
        titname: "供应商符合性检查",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "editorial"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "2"
          ? "confirmation"
          : "checkCompleted", // 确认中（2）：confirmation 检查中（0）：editorial 检查完成（1）：
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      exeStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .exeStatus,

      tableData: [],
      tableDataFX: [],
      tableDataAI: [],
      tableDataAIReq: [],
      roudMax: "",
      companyNames: [],
      expertConfirmtableData: [],
      confirmStatus: true, //专家是否已全部确认
      dialogVisible: false,
      supComCheckConfirmDetail: {},
      supComCheckConfirm: {
        confirmOpinion: ""
      },
      expertRole: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .expertRole, // 专家角色 : 1-组长 0-组员
      formData: {
        supPackQuoteId: "",
        supQuoteId: 0, // 供应商报价ID
        supCode: "" // 供应商编号
      },
      confirmCheckColumns: [
        // {
        //   prop: "packName",
        //   label: "包件名称",
        //   width: commonTableWidth.packNameWidth,
        // },
        {
          prop: "supName",
          label: "供应商",
          width: commonTableWidth.supNameWidthTwo
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "报价金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          minWidth: 130,
          align: "right",
          money: true
        },
        {
          prop: "supCode",
          label: "投标文件",
          type: "link"
        },
        {
          prop: "passFlag",
          label: "是否通过",

          type: "select"
        },
        {
          prop: "reason",
          label: "符合性检查意见",
          type: "input",
          required: true,
          width: 200
        }
      ],
      confirmCheckColumns2: [
        {
          prop: "supName",
          label: "供应商",
          width: commonTableWidth.supNameWidthTwo
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "报价金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          minWidth: 130,
          align: "right",
          money: true
        },
        {
          prop: "supCode",
          label: "投标文件",
          type: "link"
        },
        {
          prop: "passFlag",
          label: "是否通过",

          type: "select"
        },
        {
          prop: "reason",
          label: "符合性检查意见",
          type: "input",
          required: true,
          width: 200
        }
      ],
      confirmCheckColumns3: [
        {
          prop: "supName",
          label: "投标人",
          width: commonTableWidth.supNameWidthTwo
        }
        // {
        //   prop: "formStandard",
        //   label: "形式评审标准",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   prop: "qualStandard",
        //   label: "资格评审标准",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   prop: "busiStandard",
        //   label: "商务评审标准",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   prop: "techStandard",
        //   label: "技术评审标准",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   prop: "priceStandard",
        //   label: "价格评审标准",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   prop: "finalResult",
        //   label: "评审结果",
        //   align: "center",
        //   width: 100,
        // },
      ],
      rowKey: 1,
      confirmCheckColumns4: [
        {
          prop: "supName",
          label: "投标人",
          width: commonTableWidth.supNameWidthTwo
        },
        {
          prop: "reviewItemName",
          label: "评审项目",
          align: "center",
          width: 150
        },
        {
          prop: "isConformityReason",
          label: "AI分析",
          align: "center"
        }
      ],
      expertColumns: [
        {
          prop: "round",
          label: "确认轮数",
          width: 80
        },
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "confirmUserName",
          label: "专家姓名",
          width: commonTableWidth.expertName
        },
        {
          prop: "confirmResultStr",
          label: "确认结果"
        },
        {
          prop: "confirmOpinion",
          label: "确认意见",
          minWidth: 280
        },
        {
          prop: "confirmTime",
          label: "确认日期",
          width: commonTableWidth.dateTimeWidth
        },
        {
          prop: "confirmStatusStr",
          label: "确认状态"
        }
      ],
      exportExcelData: [],
      fileData: [],
      labelShow: false,
      subPackageFlag: false, //true分包，false不分包
      purchaseType: "",
      confirmBtnFlag: "0",
      rowData: [],
      rowDataAI: [],
      aiReviewFlag: "",
      reviewStatus: "",
      isNewTable: false,
      isChangeTab: true,
      propsStr: "",
      indexNum: "",
      indexPickNum: "",
      reviewList: [],
      currentColumnProp: "" // 用于跟踪当前选中的列prop
    };
  },
  created() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    qryBidPricePrepareApi({
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      purStep: "6" // 寻源环节 开标环节：6谈判环节：11
    }).then(res => {
      this.templateType = res.data.data.priceTemplateType;
    });
    this.getQuerySupComRelationCheckNew();
  },
  destroyed() {},

  mounted() {
    setTimeout(() => {
      this.getData();
    }, 500);
    this.getPackageFlag();
    this.labelShow = true;
    if (
      JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ==
        "0" &&
      JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).exeStatus == "0"
    ) {
      this.disabled = false;
    }
    let timestamp = JSON.parse(
      sessionStorage.getItem("bidEvaPrepareDetailData")
    ).evaStartTime;

    if (new Date(timestamp).getTime() > this.timestamp) {
      this.isNewTable = true;
    } else {
      this.isNewTable = false;
    }
  },
  methods: {
    // 添加处理 tableDataAIReq 表格合并的方法
    objectSpanMethodAIReq({ row, column, rowIndex, columnIndex }) {
      // 投标人列（第一列）合并
      if (columnIndex === 1) {
        // 只在第一行显示投标人名称，并合并所有行
        if (rowIndex === 0) {
          return {
            rowspan: this.tableDataAIReq.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    // 如果是分包情况下的 tableDataAIReq 合并方法
    objectSpanMethodPickAIReq(
      { row, column, rowIndex, columnIndex },
      tableData
    ) {
      // 投标人列（第一列，对应 prop 为 supName）合并
      if (columnIndex === 1) {
        // 只在第一行显示投标人名称，并合并所有行
        if (rowIndex === 0 && tableData && tableData.length > 0) {
          return {
            rowspan: tableData.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    // 改变AI结果--不分包件
    handleChangeIsConformity() {
      this.isChangeTab = false;
      let arr = [];
      let parts = this.propsStr.split("reviewStandardResult");
      let lastPart = parts[parts.length - 1];
      this.tableDataAIReq.forEach(item => {
        if (item.modifyIsConformity == "1") {
          arr.push(item);
        }
      });
      if (arr.length == this.tableDataAIReq.length) {
        this.tableDataAI[this.indexNum][this.propsStr] = "1";

        this.tableDataAI[this.indexNum].standardList[
          lastPart
        ].reviewStandardResult = "1";

        let arr0 = this.getAllReviewStandardResults(this.tableDataAI);
        let arr1 = [];
        arr0.forEach(m => {
          if (m.value == "1") {
            arr1.push(m);
          }
        });
        if (arr1.length == arr0.length) {
          this.tableDataAI[this.indexNum].finalResult = "1";
        } else {
          this.tableDataAI[this.indexNum].finalResult = "0";
        }
      } else {
        this.tableDataAI[this.indexNum].finalResult = "0";
        this.tableDataAI[this.indexNum][this.propsStr] = "0";
        this.tableDataAI[this.indexNum].standardList[
          lastPart
        ].reviewStandardResult = "0";
      }
      this.tableDataAI.forEach(ss => {
        this.tableData.forEach(pp => {
          if (ss.supName == pp.supName) {
            this.$set(pp, "passFlag", ss.finalResult == "0" ? "1" : "0");
            this.$set(
              pp,
              "passFlagStr",
              ss.finalResult == "0" ? "不通过" : "通过"
            );
          }
        });
      });
    },
    // 改变AI结果--分包件
    handleChangePickIsConformity() {
      this.isChangeTab = false;

      let obj = this.rowDataAI[this.indexPickNum];

      // this.rowDataAI.forEach(item => {
      let arr = [];
      let parts = this.propsStr.split("reviewStandardResult");
      let lastPart = parts[parts.length - 1];
      obj.tableDataAIReq.forEach(items => {
        if (items.modifyIsConformity == "1") {
          arr.push(items);
        }
      });
      if (arr.length == obj.tableDataAIReq.length) {
        this.rowDataAI[this.indexPickNum].list[this.indexNum][this.propsStr] =
          "1";

        this.rowDataAI[this.indexPickNum].list[this.indexNum].standardList[
          lastPart
        ].reviewStandardResult = "1";

        let arr0 = this.getAllReviewStandardResults(
          this.rowDataAI[this.indexPickNum].list
        );
        let arr1 = [];
        arr0.forEach(m => {
          if (m.value == "1") {
            arr1.push(m);
          }
        });
        if (arr1.length == arr0.length) {
          this.rowDataAI[this.indexPickNum].list[this.indexNum].finalResult =
            "1";
        } else {
          this.rowDataAI[this.indexPickNum].list[this.indexNum].finalResult =
            "0";
        }
      } else {
        this.rowDataAI[this.indexPickNum].list[this.indexNum].finalResult = "0";
        this.rowDataAI[this.indexPickNum].list[this.indexNum][this.propsStr] =
          "0";
        this.rowDataAI[this.indexPickNum].list[this.indexNum].standardList[
          lastPart
        ].reviewStandardResult = "0";
      }
      this.rowData.forEach(mm => {
        if (mm.packId == obj.packId) {
          mm.sscSupComPriceBOS.forEach(nn => {
            if (
              nn.supCode ==
              this.rowDataAI[this.indexPickNum].list[this.indexNum].supCode
            ) {
              this.$set(
                nn,
                "passFlag",
                this.rowDataAI[this.indexPickNum].list[this.indexNum]
                  .finalResult == "0"
                  ? "1"
                  : "0"
              );
              this.$set(
                nn,
                "passFlagStr",
                this.rowDataAI[this.indexPickNum].list[this.indexNum]
                  .finalResult == "0"
                  ? "不通过"
                  : "通过"
              );
            }
          });
        }
      });
      // });
    },
    getAllReviewStandardResults(datas) {
      let results = [];

      if (datas && datas.length > 0) {
        datas.forEach((item, index) => {
          // 获取对象的所有键
          const keys = Object.keys(item);

          // 筛选出包含 'reviewStandardResult' 的键
          const reviewKeys = keys.filter(key =>
            key.includes("reviewStandardResult")
          );

          // 收集这些键值对
          reviewKeys.forEach(key => {
            results.push({
              index: index,
              key: key,
              value: item[key]
            });
          });
        });
      }

      let resultsNew = results.filter(item => {
        return item.index == this.indexNum;
      });

      return resultsNew;
    },
    async handleGoAi(item) {
      // let aiReviewFlags = true;
      // if (this.aiReviewFlag) {
      //   if (!this.confirmStatus) {
      //     aiReviewFlags = await this.$confirm(
      //       "还有专家未提交确认结果，不允许修改AI审查结果！",
      //       "提示",
      //       {
      //         // distinguishCancelAndClose: true,
      //         showCancelButton: false,
      //         confirmButtonText: "确定",
      //         // cancelButtonText: "取消",
      //         customClass: "ccui-message-box-custom",
      //       }
      //     ).then(() => {
      //       return false;
      //     });
      //     // .catch(() => {
      //     //   return false;
      //     // });
      //   }
      // }
      // if (!aiReviewFlags) {
      //   return;
      // }
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
        // baseUrl = "http://47.108.13.132:8102";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
        // baseUrl = "http://47.108.13.132:8102";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      this.reportUrl =
        baseUrl +
        `/front/supplyChain/itemDetail?taskId=${item.taskId}&bidSubCompanyCode=${item.supCode}&reviewItemNameId=${item.reviewItemNameId}&token=` +
        sessionStorage.getItem("AItoken");
      this.dialogVisibles = true;
    },
    handleClickReq(row, index, props) {
      if (props != "finalResult") {
        // 获取当前点击列的头部信息
        let columnInfo = null;

        // 根据分包情况在不同列配置中查找
        if (this.subPackageFlag) {
          // 分包情况 - 从 rowDataAI 中查找
          const packData = this.rowDataAI.find(
            item => item.packId === row.packId
          );
          if (packData && packData.confirmCheckColumns) {
            columnInfo = packData.confirmCheckColumns.find(
              col => col.prop === props
            );
          }
        } else {
          // 不分包情况 - 从 confirmCheckColumns3 中查找
          columnInfo = this.confirmCheckColumns3.find(
            col => col.prop === props
          );
        }

        // 更新下方表格的"评审项目"列 label（将"标准"替换为"项目"）
        if (columnInfo && columnInfo.label) {
          // 将 label 中的"标准"替换为"项目"
          const newLabel = columnInfo.label.replace("标准", "项目");

          if (this.subPackageFlag) {
            // 分包情况 - 只更新当前包件的列配置
            const packIndex = this.rowDataAI.findIndex(
              item => item.packId === row.packId
            );
            console.log("分包 - packIndex:", packIndex);
            console.log("分包 - newLabel:", newLabel);
            if (packIndex !== -1) {
              this.$set(
                this.rowDataAI[packIndex],
                "currentReviewItemLabel",
                newLabel
              );
              this.rowKey++;
              this.$forceUpdate();
            }
          } else {
            // 不分包情况 - 更新 confirmCheckColumns4 中的"评审项目"列
            const reviewItemColumn = this.confirmCheckColumns4.find(
              col => col.prop === "reviewItemName"
            );
            if (reviewItemColumn) {
              reviewItemColumn.label = newLabel;
            }
          }
        }

        // 设置当前选中的列，区分包件
        if (this.subPackageFlag) {
          // 分包情况下，需要知道当前是哪个包件的表格
          // 可以通过 row.packId 或其他方式获取包件ID
          const packId =
            row.packId ||
            (this.rowDataAI[this.indexPickNum]
              ? this.rowDataAI[this.indexPickNum].packId
              : "");
          if (packId) {
            this.$set(this.activeColumns, packId, props);
          }
        } else {
          // 不分包情况保持原来逻辑
          this.currentColumnProp = props;
        }
      }

      if (props != "finalResult") {
        this.propsStr = props;
        this.indexNum = index;
        if (!this.subPackageFlag) {
          let parts = props.split("reviewStandardResult");
          let lastPart = parts[parts.length - 1];
          this.tableDataAIReq = row["list" + lastPart];
        } else {
          this.rowDataAI.forEach((item, i) => {
            // this.$set(item, "tableDataAIReq", []);
            if (item.packId == row.packId) {
              this.indexPickNum = i;
              let parts = props.split("reviewStandardResult");
              let lastPart = parts[parts.length - 1];
              this.$set(item, "tableDataAIReq", row["list" + lastPart]);
            }
          });
        }
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab == "AI符合性检查结果" && this.isChangeTab) {
        this.confirmCheckColumns3 = [
          {
            prop: "supName",
            label: "投标人",
            width: commonTableWidth.supNameWidthTwo
          }
        ];
        this.getQuerySupAiReviewList();
      }
    },
    getPackageFlag() {
      let expertSourceData = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      );

      if (
        expertSourceData.purchaseType == "50" ||
        expertSourceData.purchaseType == "53"
      ) {
        this.confirmCheckColumns.splice(4, 1);
        this.confirmCheckColumns2.splice(4, 1);
      }
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    checkedChange(value) {
      if (value && !this.radio) {
        // this.radio = "1";
        this.radio = "";
      } else if (!value) {
        this.radio = "";
      }
    },
    radioChange(value) {
      this.checked = true;
    },
    confirmOpinionChange(value) {
      this.confirmBtnFlag = "0";
    },
    confirmBtn(value) {
      console.log(value, "confirmOpinion");
      if (value === "0") {
        if (!this.supComCheckConfirm.confirmOpinion) {
          this.supComCheckConfirm.confirmOpinion = "同意";
          this.confirmBtnFlag = "1";
        }
      }
      if (value === "1") {
        if (
          this.supComCheckConfirm.confirmOpinion == "" ||
          this.confirmBtnFlag == "1"
        ) {
          this.supComCheckConfirm.confirmOpinion = "";
          this.confirmBtnFlag = "0";
          this.$message({
            message: "请输入确认意见！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          return false;
        }
      }
      this.dealSupComCheckConfirm(
        // this.radio1 === "0" ? "1" : this.radio1 === "1" ? "0" : this.radio1
        value === "0" ? "1" : value === "1" ? "0" : value
      );
    },
    companyDetail() {
      if (this.companyNames.length < 2) {
        this.$message({
          message: "至少需要2家企业才可以进行供应商关系查询",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      companyDetail({
        companyNames: this.companyNames.join(",")
      }).then(res => {
        // let url = this.$router.resolve({
        //   name: "relationship",
        //   query: {
        //     flowSrc: res.data.data
        //   }
        // });
        window.open(res.data.data, "_blank");
      });
    },
    init() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        isShowLoading: true,
        purStep: "0804"
      }).then(res => {
        this.$set(this, "labelShow", false);
        this.billStatus = res.data.data.billStatus;
        this.exeStatus = res.data.data.exeStatus;
        if (this.billStatus === "0" && res.data.data.exeStatus == "0") {
          this.disabled = false;
        }
        this.$set(
          this,
          "labelType",
          res.data.data.billStatus === "0"
            ? "editorial"
            : res.data.data.billStatus === "2"
            ? "confirmation"
            : "checkCompleted"
        );
        // this.labelType =
        //   this.billStatus === "0"
        //     ? "editorial"
        //     : this.billStatus === "2"
        //     ? "confirmation"
        //     : "checkCompleted";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.$set(this, "labelShow", true);
        this.getData();
        this.getQuerySupComRelationCheckNew();
        this.reload();
      });
      // this.getCheckDetail();
    },
    getCheckDetail() {
      SupComRelationCheck({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        operType:
          JSON.parse(sessionStorage.getItem("expertSourceData")).expertRole == 1
            ? 1
            : 2,
        qryFileFlag: true
      }).then(res => {
        res.data.data.infoList.forEach(item => {
          if (item.expertRole == 1) {
            this.radio = item.supRelationCheck;
          } else {
            // this.radio1 = item.supCheckResult;
            // this.supComCheckConfirm.confirmOpinion = item.confirmOpinion;
          }
        });

        this.fileData = res.data.data.fileInfoBOs;
        if (this.radio || this.radio1) {
          this.checked = true;
        }
      });
    },
    // 查询符合性检查-供应商关联关系检查数据new
    getQuerySupComRelationCheckNew() {
      querySupComRelationCheckNew({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        isShowLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.list.forEach(item => {
            if (item.riskCheck == "") {
              item.hasRisk == 0
                ? (item.riskCheck = "0")
                : (item.riskCheck = "1");
            }
          });
          this.tableDataFX = res.data.data.list;
          this.fileData = res.data.data.fileInfoBOs;
        }
      });
    },
    // 查询ai符合性检查列表数据
    getQuerySupAiReviewList() {
      querySupAiReviewList({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        isShowLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          if (res.data.data && res.data.data.length > 0) {
            if (!this.subPackageFlag) {
              let list0 = res.data.data[0]?.list;
              if (list0 && list0.length > 0) {
                let list = list0[0]?.standardList;
                if (list && list.length > 0) {
                  list.forEach((x, i) => {
                    let propStr = Object.keys(x).find(
                      k => k === "reviewStandardResult"
                    );
                    this.confirmCheckColumns3.push({
                      prop: propStr + i,
                      label: x.reviewStandard,
                      align: "center",
                      width: 100
                    });
                  });
                }
                this.confirmCheckColumns3.push({
                  prop: "finalResult",
                  label: "评审结果",
                  align: "center",
                  width: 100
                });

                list0.forEach(z => {
                  z.standardList.forEach((y, index) => {
                    let propStr = Object.keys(y).find(
                      k => k === "reviewStandardResult"
                    );
                    let listIndex = "list" + index;
                    y.list.forEach(m => {
                      m.supName = z.supName;
                      m.supCode = z.supCode;
                      m.modifyIsConformity = String(m.modifyIsConformity);
                    });
                    z[propStr + index] = y.reviewStandardResult;
                    z[listIndex] = y.list;
                  });
                  this.tableData.forEach(pp => {
                    if (z.supName == pp.supName) {
                      if (!pp.passFlag) {
                        this.$set(
                          pp,
                          "passFlag",
                          z.finalResult == "0" ? "1" : "0"
                        );
                      }
                      if (!pp.passFlagStr) {
                        this.$set(
                          pp,
                          "passFlagStr",
                          z.finalResult == "0" ? "不通过" : "通过"
                        );
                      }
                    }
                  });
                });

                this.tableDataAI = list0;
                this.reviewList = res.data.data;
              }
            } else {
              res.data.data.forEach(x => {
                x.confirmCheckColumns = [
                  {
                    prop: "supName",
                    label: "投标人",
                    width: commonTableWidth.supNameWidthTwo
                  }
                ];
                x.list.forEach(y => {
                  y.standardList.forEach((z, i) => {
                    let propStr = Object.keys(z).find(
                      k => k === "reviewStandardResult"
                    );
                    // 创建新的列配置项
                    let newColumn = {
                      prop: propStr + i,
                      label: z.reviewStandard,
                      align: "center",
                      width: 100
                    };

                    // 检查是否已存在相同label的列，避免重复
                    let isDuplicate = x.confirmCheckColumns.some(
                      column => column.label === newColumn.label
                    );

                    // 只有当label不重复时才添加
                    if (!isDuplicate) {
                      x.confirmCheckColumns.push(newColumn);
                    }
                  });
                });
                x.confirmCheckColumns.push({
                  prop: "finalResult",
                  label: "评审结果",
                  align: "center",
                  width: 100
                });
              });

              res.data.data.forEach(xx => {
                xx.list.forEach(yy => {
                  yy.standardList.forEach((zz, index) => {
                    let propStr = Object.keys(zz).find(
                      k => k === "reviewStandardResult"
                    );
                    let listIndex = "list" + index;
                    zz.list.forEach(m => {
                      m.supName = yy.supName;
                      m.supCode = yy.supCode;
                      m.modifyIsConformity = String(m.modifyIsConformity);
                    });
                    yy[propStr + index] = zz.reviewStandardResult;
                    yy[listIndex] = zz.list;
                  });
                  this.rowData.forEach(mm => {
                    if (mm.packId == xx.packId) {
                      mm.sscSupComPriceBOS.forEach(nn => {
                        if (nn.supCode == yy.supCode) {
                          if (!nn.passFlag) {
                            this.$set(
                              nn,
                              "passFlag",
                              yy.finalResult == "0" ? "1" : "0"
                            );
                          }
                          if (!nn.passFlagStr) {
                            this.$set(
                              nn,
                              "passFlagStr",
                              yy.finalResult == "0" ? "不通过" : "通过"
                            );
                          }
                        }
                      });
                    }
                  });
                });
              });

              this.rowDataAI = res.data.data;
            }
          }
        }
      });
    },
    // 保存ai符合性检查数据
    async getDealSupComRelationCheckSaveNew() {
      let params = {};
      params.isShowLoading = true;
      params.schemeId = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      ).schemeId;
      params.joinExpertId = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      ).joinExpertId;
      params.operType =
        JSON.parse(sessionStorage.getItem("expertSourceData")).expertRole == 1
          ? 1
          : 2; //组长传1，组员传2
      params.list = this.tableDataFX;
      if (this.$refs.attachmentUpload) {
        params.FileInfoBOs = this.$refs.attachmentUpload.fileData;
        if (params.FileInfoBOs && params.FileInfoBOs.length > 0) {
          params.FileInfoBOs.forEach((item, index) => {
            item.uploadTime = item.createTime;
          });
        }
        let fileData = this.$refs.attachmentUpload.fileData;
        let fileinfoIds = [];
        if (fileData.length > 0) {
          fileData.forEach(item => {
            if (item.fileinfoId) {
              fileinfoIds.push(item.fileinfoId);
            }
          });
        }
        params.fileinfoIds = fileinfoIds;
      }
      let flag = true;
      await dealSupComRelationCheckSaveNew(params).then(res => {
        if (res.data.code == 0) {
          return (flag = true);
        } else {
          return (flag = false);
        }
      });
      return flag;
    },
    getData() {
      // 供应商符合性检查结果列表
      qrySupComCheckListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        isShowLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.aiReviewFlag = res.data.data.aiReviewFlag;
          if (this.aiReviewFlag == 1) {
            this.$nextTick(() => {
              this.handleClick(this.activeName);
            });
          } else {
            this.activeName = "专家确认符合性检查结果";
          }
          this.reviewStatus = res.data.data.reviewStatus;
          this.exportExcelData = res.data.data.rows;
          let data = [];
          let devspan = 0;
          // 通过包件id进行排序
          res.data.data.rows.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          let companyNames = [];
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.rowData = JSON.parse(JSON.stringify(res.data.data.rows));
            this.rowData.forEach(x => {
              if (x.sscSupComPriceBOS && x.sscSupComPriceBOS.length > 0) {
                x.sscSupComPriceBOS.forEach(y => {
                  if (this.aiReviewFlag == 1) {
                    if (y.anaProgress === "") {
                      this.$set(y, "anaProgress", "4");
                    }
                  }
                  if (this.aiReviewFlag == 1) {
                    if (this.billStatus == "0" && this.exeStatus == "0") {
                      if (y.anaProgress && y.anaProgress == "4") {
                        this.$set(y, "disabled", false);
                      } else {
                        this.$set(y, "disabled", true);
                      }
                    } else {
                      this.$set(y, "disabled", true);
                    }
                  } else {
                    this.$set(y, "disabled", this.disabled);
                  }

                  y.anaProgressStr =
                    y.anaProgress == 0 || y.anaProgress == 1
                      ? "符合性审查进行中"
                      : y.anaProgress == 2 || y.anaProgress == 3
                      ? "审查已完成"
                      : y.anaProgress == 4
                      ? "符合性审查失败"
                      : "";
                  // y.passFlag =
                  //   y.passFlag != ""
                  //     ? y.passFlag
                  //     : y.aiReviewStatus == "0"
                  //     ? "0"
                  //     : "1";
                });
              }
            });
            res.data.data.rows.forEach((item, index) => {
              if (item.packId == 0) {
                this.confirmCheckColumns.splice(4, 1);
              }
              if (index > 0) {
                devspan +=
                  res.data.data.rows[index - 1].sscSupComPriceBOS.length;
              }
              if (item.sscSupComPriceBOS && item.sscSupComPriceBOS.length > 0) {
                item.sscSupComPriceBOS.forEach((itemtow, indextow) => {
                  companyNames.push(itemtow.supName);
                  companyNames.push(itemtow.supCode);
                  if (this.aiReviewFlag == 1) {
                    if (this.billStatus == "0" && this.exeStatus == "0") {
                      if (itemtow.anaProgress && itemtow.anaProgress == "4") {
                        this.$set(itemtow, "disabled", false);
                      } else {
                        this.$set(itemtow, "disabled", true);
                      }
                    } else {
                      this.$set(itemtow, "disabled", true);
                    }
                  } else {
                    this.$set(itemtow, "disabled", this.disabled);
                  }

                  let obj = {
                    idx: this.subPackageFlag ? index + 1 : indextow + 1,
                    packName: item.packName, // 是否流标packStatus 1正常2流标（评标前流标）5流标（评标后流标）
                    packStatus: item.packStatus,
                    packId: item.packId,
                    supCode: itemtow.supCode,
                    supName: itemtow.supName,
                    supCategoryName: itemtow.supCategoryName,
                    supLevelName: itemtow.supLevelName,
                    supTypeNewName: itemtow.supTypeNewName,
                    supQuoteId: itemtow.supQuoteId,
                    priceAmount: itemtow.priceAmount,
                    // passFlag:
                    //   this.billStatus === "0"
                    //     ? itemtow.passFlag
                    //     : itemtow.passFlag == 0
                    //     ? "通过"
                    //     : "不通过",
                    passFlag: itemtow.passFlag,
                    passFlagStr: itemtow.passFlagStr,
                    // passFlag:
                    //   itemtow.passFlag != ""
                    //     ? itemtow.passFlag
                    //     : itemtow.aiReviewStatus == "0"
                    //     ? "1"
                    //     : "0",
                    // passFlagStr:
                    //   itemtow.passFlagStr != ""
                    //     ? itemtow.passFlagStr
                    //     : itemtow.aiReviewStatus === "0"
                    //     ? "不通过"
                    //     : itemtow.aiReviewStatus === "1"
                    //     ? "通过"
                    //     : itemtow.passFlagStr,
                    disabled: itemtow.disabled,
                    reason: itemtow.reason
                      ? itemtow.reason
                      : itemtow.passFlagStr,

                    // : this.expertRole === "1" && this.billStatus === "0"
                    // ? "通过"
                    // : "",
                    round: itemtow.round,
                    rowspan: item.sscSupComPriceBOS.length,
                    devspan: devspan,
                    anaProgress: itemtow.anaProgress,
                    anaProgressStr:
                      itemtow.anaProgress == 1 || itemtow.anaProgress == 0
                        ? "符合性审查进行中"
                        : itemtow.anaProgress == 2 || itemtow.anaProgress == 3
                        ? "审查已完成"
                        : itemtow.anaProgress == 4
                        ? "符合性审查失败"
                        : ""
                  };
                  data.push(obj);
                });
              }
            });
            this.tableData = JSON.parse(JSON.stringify(data));
          }
          this.companyNames = Array.from(new Set(companyNames));
        }
      });
      // 专家确认列表
      qrySupComCheckConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        round: "",
        confirmType: "1"
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          this.roudMax = res.data.data.roundMax;
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                confirmId: itemtow.confirmId,
                round: itemtow.round,
                schemeId: itemtow.schemeId,
                confirmUserId: itemtow.confirmUserId,
                confirmUserName: itemtow.confirmUserName,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: itemtow.confirmOpinion,
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              newData.push(obj);
            });
          });
          this.expertConfirmtableData = newData;
          if (newData.length > 0) {
            newData.forEach(item => {
              if (
                item.confirmStatus === "0" &&
                res.data.data.roundMax == item.round
              ) {
                this.confirmStatus = false;
              }
            });
          }
        }
      });
      qrySupComCheckConfirmDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        confirmUserId: JSON.parse(localStorage.getItem("userInfo")).openId
      }).then(res => {
        this.supComCheckConfirmDetail = res.data.data;
      });
    },
    //符合性检查结果
    objectSpanMethodReport({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2 && this.subPackageFlag) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    goTo() {
      window.open("https://www.cneptp.com/");
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },

    changeLostFlag(row, index) {
      // if (row.passFlag === "1") {
      //   // 不通过 reason
      //   this.$set(this.tableData[index], "reason", "不通过");
      // } else {
      //   // 通过
      //   this.$set(this.tableData[index], "reason", "通过");
      // }
    },
    handleInput(row, index) {
      // if (row.passFlag === "1") {
      //   // 不通过 reason
      this.$set(this.tableData[index], "reason", row.reason);
      // } else {
      //   // 通过
      //   this.$set(this.tableData[index], "reason", "通过");
      // }
    },

    // 校验专家说明：若专家将审查细则的审查结果修改为与AI审查结果不一致，专家说明必填；未改变则不必填
    checkExpertExplanation() {
      let invalidRows = [];
      let checkDetailList = (list, packName) => {
        (list || []).forEach(row => {
          let aiResult = row.modifyIsConformity;
          let expertResult = row.isConformity;
          if (
            aiResult != null &&
            aiResult !== "" &&
            aiResult !== "null" &&
            aiResult !== "undefined" &&
            expertResult != null &&
            expertResult !== "" &&
            String(expertResult) !== String(aiResult) &&
            !(row.expertFixDesc || "").trim()
          ) {
            invalidRows.push({ row: row, packName: packName });
          }
        });
      };
      let sourceList = this.subPackageFlag ? this.rowDataAI : this.reviewList;
      (sourceList || []).forEach(pack => {
        (pack.list || []).forEach(sup => {
          (sup.standardList || []).forEach(std => {
            checkDetailList(std.list, pack.packName);
          });
        });
      });
      if (invalidRows.length > 0) {
        // 按“包件 + 投标人”分组，汇总该供应商下全部与AI审查结果不一致且专家说明未填写的审查细则
        let groupMap = {};
        let groupList = [];
        invalidRows.forEach(item => {
          let groupKey = `${item.packName || ""}||${item.row.supName || ""}`;
          let group = groupMap[groupKey];
          if (!group) {
            group = {
              packName: item.packName,
              supName: item.row.supName,
              details: []
            };
            groupMap[groupKey] = group;
            groupList.push(group);
          }
          group.details.push(
            `“${item.row.reviewStandard}-${item.row.reviewItemName}”`
          );
        });
        let messageHtml = groupList
          .map(group => {
            let packTip =
              this.subPackageFlag && group.packName
                ? `包件${group.packName}：`
                : "";
            return `${packTip}投标人【${
              group.supName
            }】的审查细则${group.details.join("、")}`;
          })
          .join("<br/>");
        this.$message({
          dangerouslyUseHTMLString: true,
          message: `以下审查结果与AI审查结果不一致，专家说明为必填项：<br/>${messageHtml}`,
          type: "error",
          duration: 5000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      return true;
    },
    async dealSupComCheckSave(type) {
      if (type == "2" && this.aiReviewFlag == 1) {
        let isFlags = false;
        if (this.subPackageFlag) {
          this.rowData.forEach(x => {
            if (x.sscSupComPriceBOS && x.sscSupComPriceBOS.length > 0) {
              x.sscSupComPriceBOS.forEach(y => {
                if (y.anaProgress == 0 || y.anaProgress == 1) {
                  isFlags = true;
                }
              });
            }
          });
          if (isFlags) {
            this.$message.error("有符合性审查进行中的数据，不能提交确认");
            return;
          }
        } else {
          this.tableData.forEach(item => {
            if (item.anaProgress == 0 || item.anaProgress == 1) {
              isFlags = true;
            }
          });
          if (isFlags) {
            this.$message.error("有符合性审查进行中的数据，不能提交确认");
            return;
          }
        }
      }
      // 提示“还有专家未提交确认结果，不允许提交确认”
      let tipTitle = "";
      if (type == 1) {
        tipTitle = "还有专家未提交确认结果，不允许保存！";
      } else if (type == 2) {
        tipTitle = "还有专家未提交确认结果，不允许提交确认！";
      }
      let aiReviewFlags = true;
      if (this.aiReviewFlag) {
        if (!this.confirmStatus) {
          aiReviewFlags = await this.$confirm(tipTitle, "提示", {
            // distinguishCancelAndClose: true,
            showCancelButton: false,
            confirmButtonText: "确定",
            // cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }).then(() => {
            return false;
          });
          // .catch(() => {
          //   return false;
          // });
        }
      }
      if (!aiReviewFlags) {
        return;
      }

      // 提示“还有专家未提交确认结果，是再次提交确认”
      let isConfirm = true;
      if (!this.confirmStatus) {
        isConfirm = await this.$confirm(
          // "还有专家未提交确认结果，是否再次提交确认？",
          tipTitle,
          "提示",
          {
            // distinguishCancelAndClose: true,
            // confirmButtonText: "确定",
            // cancelButtonText: "取消",
            // customClass: "ccui-message-box-custom"
            // distinguishCancelAndClose: true,
            showCancelButton: false,
            confirmButtonText: "确定",
            customClass: "ccui-message-box-custom"
          }
        ).then(() => {
          return false;
        });
        // .catch(() => {
        //   return false;
        // });
      }
      if (!isConfirm) {
        return;
      }
      // 符合性检查意见不能为空

      let flag = true;
      let sscPackSupComCheckBOS = [];
      if (!this.subPackageFlag) {
        this.tableData.forEach(item => {
          // 已流标包件（packStatus 2/5）不校验是否通过、符合性检查意见必填
          if (item.packStatus == 2 || item.packStatus == 5) {
            return;
          }
          if (!item.reason) {
            flag = false;
          }
        });

        let packIdArr = [];
        this.tableData.forEach(item => {
          if (packIdArr.every(packItem => packItem.packId !== item.packId)) {
            packIdArr.push(item);
          }
        });

        packIdArr.forEach(item => {
          let sscPackSupComCheckBO = {};
          let sscSupComPriceBOS = [];
          sscPackSupComCheckBO.packId = item.packId;
          sscPackSupComCheckBO.packName = item.packName;
          this.tableData.forEach(tableItem => {
            if (item.packId === tableItem.packId) {
              let sscSupComPriceBO = {};
              sscSupComPriceBO.supCode = tableItem.supCode;
              sscSupComPriceBO.supName = tableItem.supName;
              sscSupComPriceBO.priceAmount = tableItem.priceAmount;
              sscSupComPriceBO.passFlag = tableItem.passFlag;
              sscSupComPriceBO.passFlagStr = tableItem.passFlagStr;
              sscSupComPriceBO.reason = tableItem.reason;
              sscSupComPriceBO.round = tableItem.round;
              sscSupComPriceBOS.push(sscSupComPriceBO);
            }
          });
          sscPackSupComCheckBO.sscSupComPriceBOS = sscSupComPriceBOS;
          sscPackSupComCheckBOS.push(sscPackSupComCheckBO);
        });
      } else {
        this.rowData.forEach(x => {
          // 已流标包件（packStatus 2/5）不校验是否通过、符合性检查意见必填
          if (x.packStatus == 2 || x.packStatus == 5) {
            return;
          }
          if (x.sscSupComPriceBOS && x.sscSupComPriceBOS.length > 0) {
            x.sscSupComPriceBOS.forEach(y => {
              if (!y.reason) {
                flag = false;
              }
            });
          }
        });
        sscPackSupComCheckBOS = this.rowData;
        // let packIdArr = [];
        // this.rowData.forEach(item => {
        //   if (packIdArr.every(packItem => packItem.packId !== item.packId)) {
        //     packIdArr.push(item);
        //   }
        // });

        // packIdArr.forEach(item => {
        //   let sscPackSupComCheckBO = {};
        //   let sscSupComPriceBOS = [];
        //   sscPackSupComCheckBO.packId = item.packId;
        //   sscPackSupComCheckBO.packName = item.packName;
        //   this.tableData.forEach(tableItem => {
        //     if (item.packId === tableItem.packId) {
        //       let sscSupComPriceBO = {};
        //       sscSupComPriceBO.supCode = tableItem.supCode;
        //       sscSupComPriceBO.supName = tableItem.supName;
        //       sscSupComPriceBO.priceAmount = tableItem.priceAmount;
        //       sscSupComPriceBO.passFlag = tableItem.passFlag;
        //       sscSupComPriceBO.passFlagStr = tableItem.passFlagStr;
        //       sscSupComPriceBO.reason = tableItem.reason;
        //       sscSupComPriceBO.round = tableItem.round;
        //       sscSupComPriceBOS.push(sscSupComPriceBO);
        //     }
        //   });
        //   sscPackSupComCheckBO.sscSupComPriceBOS = sscSupComPriceBOS;
        //   sscPackSupComCheckBOS.push(sscPackSupComCheckBO);
        // });
      }
      if (flag) {
        // 审查细则结果修改为与AI审查结果不一致时，专家说明必填
        if (this.aiReviewFlag == 1 && !this.checkExpertExplanation()) {
          return;
        }
        let isFlag = false;
        if (!this.isNewTable) {
          if (!this.checked) {
            this.$message({
              message: "请选择供应商关联关系检查！",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return (isFlag = false);
          } else {
            isFlag = true;
          }

          if (
            this.radio == 1 &&
            this.fileData.length == 0 &&
            this.$refs.attachmentUpload.fileData.length == 0
          ) {
            this.$message({
              message: "请上传存在风险供应商的关联关系检查结果附件!",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return (isFlag = false);
          } else {
            isFlag = true;
          }
        } else {
          // 检查是否有未选择风险排查结果的记录
          const incompleteRecord = this.tableDataFX.find(
            item => !item.riskCheck
          );

          if (incompleteRecord) {
            this.$message({
              message: "供应商风险排查中的【方案是否存在问题】未选择！",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            isFlag = false;
          } else {
            isFlag = true;
          }

          // 当被预警的供应商选择无问题时，增加字段理由，手动录入，未录入时，保持或提交时提示：请填写理由
          for (let e in this.tableDataFX) {
            if (
              this.tableDataFX[e].hasRisk == "1" &&
              this.tableDataFX[e].riskCheck == "0" &&
              !this.tableDataFX[e].reason
            ) {
              this.$message({
                message: `供应商风险排查中第${+e +
                  1}行的【是否存在】为是,【方案是否存在问题】为无问题时【理由】为必填项！`,
                type: "error",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              return (isFlag = false);
            } else {
              isFlag = true;
            }
          }

          // 检查风险排查结果的记录为有问题的
          const isFileData = this.tableDataFX.find(
            item => item.riskCheck == "1"
          );

          if (isFileData && this.$refs.attachmentUpload.fileData.length == 0) {
            this.$message({
              message: "请上传存在风险供应商风险排查核查结果附件!",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return (isFlag = false);
          } else {
            isFlag = true;
          }
        }
        if (isFlag) {
          let params = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            operType: type,
            isShowLoading: true,
            sscPackSupComCheckBOS: sscPackSupComCheckBOS,
            reviewList: this.subPackageFlag ? this.rowDataAI : this.reviewList
          };

          // 新增：只有已提交确认（确认中状态）后再点击“保存”，才弹框二次确认；未提交确认时保存保持原逻辑
          if (type == "1" && this.billStatus === "2") {
            let canSave = await this.$confirm(
              "保存后需要发起新的确认，是否保存？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "ccui-message-box-custom"
              }
            )
              .then(() => true)
              .catch(() => false);
            if (!canSave) {
              return;
            }
          }
          dealSupComCheckSaveApi(params).then(async res => {
            if (res.data.code == "0") {
              let flag = false;
              if (!this.isNewTable) {
                flag = await this.SupComRelationCheckSave();
              } else {
                flag = await this.getDealSupComRelationCheckSaveNew();
              }
              this.disabled = true;
              if (flag) {
                this.init();
                this.$message({
                  message: type == "1" ? "保存成功" : "提交确认成功",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
            }
          });
        }
      } else {
        this.$message({
          message: "符合性检查意见不能为空！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    dealSupComCheckConfirm(type) {
      if (!this.supComCheckConfirm.confirmOpinion) {
        this.$message({
          message: "请输入确认意见！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      console.log("dealSupComCheckConfirm");
      dealSupComCheckConfirmApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        confirmId: this.supComCheckConfirmDetail.confirmId,
        confirmResult: type,
        confirmOpinion: this.supComCheckConfirm.confirmOpinion,
        isShowPageLoading: true
      }).then(async res => {
        if (res.data.code == "0") {
          let flag = await this.SupComRelationCheckSave();
          if (flag) {
            this.init();
            this.$message({
              message: "确认成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        }
      });
    },
    async SupComRelationCheckSave() {
      let params = {};
      params.isShowLoading = true;
      params.schemeId = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      ).schemeId;
      params.joinExpertId = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      ).joinExpertId;
      params.operType =
        JSON.parse(sessionStorage.getItem("expertSourceData")).expertRole == 1
          ? 1
          : 2; //组长传1，组员传2
      if (
        JSON.parse(sessionStorage.getItem("expertSourceData")).expertRole == 1
      ) {
        params.supRelationCheck = this.radio; //供应商关联关系检查
      } else {
        params.supCheckResult = this.radio1; //供应商符合性检查结果
        params.confirmOpinion = this.supComCheckConfirm.confirmOpinion;
      }
      params.purStep = "8";
      if (this.$refs.attachmentUpload) {
        params.FileInfoBOs = this.$refs.attachmentUpload.fileData;
        if (params.FileInfoBOs && params.FileInfoBOs.length > 0) {
          params.FileInfoBOs.forEach((item, index) => {
            item.uploadTime = item.createTime;
          });
        }
        let fileData = this.$refs.attachmentUpload.fileData;
        let fileinfoIds = [];
        if (fileData.length > 0) {
          fileData.forEach(item => {
            if (item.fileinfoId) {
              fileinfoIds.push(item.fileinfoId);
            }
          });
        }
        params.fileinfoIds = fileinfoIds;
      }
      let flag = true;
      await SupComRelationCheckSave(params).then(res => {
        if (res.data.code == 0) {
          return (flag = true);
        } else {
          return (flag = false);
        }
      });
      return flag;
    },
    edit() {
      this.disabled = false;
      this.rowData.forEach(x => {
        if (x.sscSupComPriceBOS && x.sscSupComPriceBOS.length > 0) {
          x.sscSupComPriceBOS.forEach(y => {
            this.$set(y, "disabled", this.disabled);
            if (y.anaProgress && y.anaProgress == "4") {
              this.$set(y, "disabled", false);
            } else {
              // 智能评标
              if (this.aiReviewFlag == 1) {
                if (this.billStatus === "0" && this.exeStatus == "0") {
                  this.$set(y, "disabled", this.disabled);
                } else {
                  this.$set(y, "disabled", true);
                }
              } else {
                if (
                  (this.billStatus === "0" || this.billStatus === "2") &&
                  (this.exeStatus == "0" || this.exeStatus == "2")
                ) {
                  this.$set(y, "disabled", this.disabled);
                } else {
                  this.$set(y, "disabled", true);
                }
              }
            }
          });
        }
      });
      this.tableData.forEach(y => {
        this.$set(y, "disabled", this.disabled);
        if (y.anaProgress && y.anaProgress == "4") {
          this.$set(y, "disabled", false);
        } else {
          // 智能评标
          if (this.aiReviewFlag == 1) {
            if (this.billStatus === "0" && this.exeStatus == "0") {
              this.$set(y, "disabled", this.disabled);
            } else {
              this.$set(y, "disabled", true);
            }
          } else {
            if (
              (this.billStatus === "0" || this.billStatus === "2") &&
              (this.exeStatus == "0" || this.exeStatus == "2")
            ) {
              this.$set(y, "disabled", this.disabled);
            } else {
              this.$set(y, "disabled", true);
            }
          }
        }
      });
      this.tableData.forEach(y => {
        this.$set(y, "disabled", this.disabled);
        if (y.anaProgress && y.anaProgress == "4") {
          this.$set(y, "disabled", false);
        } else {
          // 智能评标
          if (this.aiReviewFlag == 1) {
            if (this.billStatus === "0" && this.exeStatus == "0") {
              this.$set(y, "disabled", this.disabled);
            } else {
              this.$set(y, "disabled", true);
            }
          } else {
            if (
              (this.billStatus === "0" || this.billStatus === "2") &&
              (this.exeStatus == "0" || this.exeStatus == "2")
            ) {
              this.$set(y, "disabled", this.disabled);
            } else {
              this.$set(y, "disabled", true);
            }
          }
        }
      });
    },
    async dealSupComCheckEffect() {
      if (this.aiReviewFlag == 1) {
        let isFlags = false;
        if (this.subPackageFlag) {
          this.rowData.forEach(x => {
            if (x.sscSupComPriceBOS && x.sscSupComPriceBOS.length > 0) {
              x.sscSupComPriceBOS.forEach(y => {
                if (y.anaProgress == 0 || y.anaProgress == 1) {
                  isFlags = true;
                }
              });
            }
          });
          if (isFlags) {
            this.$message.error("有符合性审查进行中的数据，不能生效");
            return;
          }
        } else {
          this.tableData.forEach(item => {
            if (item.anaProgress == 0 || item.anaProgress == 1) {
              isFlags = true;
            }
          });
          if (isFlags) {
            this.$message.error("有符合性审查进行中的数据，不能生效");
            return;
          }
        }
      }
      // 审查细则结果修改为与AI审查结果不一致时，专家说明必填
      if (this.aiReviewFlag == 1 && !this.checkExpertExplanation()) {
        return;
      }
      await this.qryExpertConfirmList();
      // 校验专家确认状态：只要有任意一位专家未确认，直接拦截
      let unconfirmedExperts = [];
      this.expertConfirmtableData.forEach(item => {
        if (item.confirmStatus === "0" && item.round == this.roudMax) {
          unconfirmedExperts.push(item.confirmUserName);
        }
      });

      if (unconfirmedExperts.length > 0) {
        this.$message({
          message: `专家${unconfirmedExperts.join("、")}尚未确认，不允许生效！`,
          type: "error",
          duration: 5000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }

      // 所有专家已确认，调用生效接口
      dealSupComCheckEffectApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        isShowPageLoading: true,
        aiReviewFlag: this.aiReviewFlag
      }).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: "符合性检查生效成功！",
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.init();
        }
      });
    },
    qryExpertConfirmList() {
      // 专家确认列表
      qrySupComCheckConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        round: "",
        confirmType: "1"
      }).then(res => {
        if (res.data.code === "0") {
          this.confirmStatus = true;
          let list = {};
          this.roudMax = res.data.data.roundMax;
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                confirmId: itemtow.confirmId,
                round: itemtow.round,
                schemeId: itemtow.schemeId,
                confirmUserId: itemtow.confirmUserId,
                confirmUserName: itemtow.confirmUserName,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: itemtow.confirmOpinion,
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              newData.push(obj);
            });
          });
          this.expertConfirmtableData = newData;
          if (newData.length > 0) {
            newData.forEach(item => {
              if (
                item.confirmStatus === "0" &&
                res.data.data.roundMax == item.round
              ) {
                this.confirmStatus = false;
              }
            });
          }
        }
      });
    },
    // 导出开始
    exportPdf() {
      supComCheckDetailMobilePdfExport({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        let openUrl = document.createElement("a");
        openUrl.style.display = "none";
        openUrl.href =
          res.data.data.ossUrl +
          "&fileName=" +
          encodeURIComponent(encodeURIComponent(res.data.data.fileName));
        document.body.appendChild(openUrl);
        openUrl.setAttribute(
          "download",
          encodeURIComponent(encodeURIComponent(res.data.data.fileName))
        );
        openUrl.click();
      });
      return;
      // this.exportData = [];
      // if (this.tableData > 5000) {
      //   this.$message({
      //     message: "暂不支持5000行以上大批量数据导出",
      //     type: "warning",
      //
      //     offset: document.documentElement.clientHeight / 2 - 21
      //   });
      // } else {
      //   this.exportExcelData.forEach((item, index) => {
      //     item.sscSupComPriceBOS.forEach((aItem, aIndex) => {
      //       this.exportData.push({
      //         id: index + 1,
      //         packName: item.packName,
      //         supName: aItem.supName,
      //         priceAmount: aItem.priceAmount,
      //         passFlagStr: aItem.passFlagStr,
      //         reason: aItem.reason
      //       });
      //     });
      //   });
      //   if (this.ExcelJS) {
      //     this.exportDefaultAll();
      //   } else {
      //     this.exportCompatibleAll();
      //   }
      // }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("供应商符合性检查结果");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["供应商符合性检查结果"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "包件名称",
        "供应商",
        "报价金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
        "是否通过",
        "符合性检查意见"
      ]);
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "packName", width: 25 },
        { key: "supName", width: 25 },
        { key: "priceAmount", width: 25 },
        { key: "passFlagStr", width: 50 },
        { key: "reason", width: 50 }
      ];
      let spanList = [];
      let start = 4;
      this.exportExcelData.forEach((item, index) => {
        let devspan = 0;
        devspan += item.sscSupComPriceBOS.length;
        item.sscSupComPriceBOS.forEach((aItem, aIndex) => {
          ws1.addRow([
            index + 1,
            item.packName,
            aItem.supName,
            aItem.priceAmount,
            aItem.passFlagStr,
            aItem.reason
          ]);
        });
        spanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      spanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        ws1.mergeCells("B" + item.start + ":B" + item.end);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "供应商符合性检查结果.xlsx");
    },
    exportCompatibleAll() {
      const header = [
        "序号",
        "包件名称",
        "供应商",
        "报价金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
        "是否通过",
        "符合性检查意见"
      ];
      const filterVal = [
        "id",
        "packName",
        "supName",
        "priceAmount",
        "passFlagStr",
        "reason"
      ];
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "供应商符合性检查结果"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.star {
  color: #ff1818;
}

.wd2 {
  width: 20px;
}

.wd10 {
  width: 100px;
}

.wd20 {
  width: 200px;
}

.group-btn-fuhe::after {
  display: block;
  content: "";
  height: 0;
  overflow: hidden;
  clear: both;
}

.group-btn-fuhe {
  margin-top: 15px;
}

.btn-radio-right {
  float: left;
  margin-right: 100px;
}

/deep/.ccui-tab-iframe {
  .operate {
    position: absolute;
    background: transparent;
    bottom: auto;
    top: 10px;
    right: 0;
    left: auto;
    width: auto;
  }
}

/deep/.el-radio.is-bordered {
  .el-radio__input {
    display: none;
  }

  color: #0089ef;
  border-color: #0089ef;
  height: 35px;
  padding: 10px 20px 0 10px;
}

.searchSup {
  color: #999;
  position: absolute;

  button {
    margin-left: 15px;
  }

  right: 360px;
  top: 23px;
}

.word-wrap-fhjc {
  word-break: break-all;
  margin-bottom: 15px;
}

/deep/.el-dialog {
  overflow: hidden;
  margin-top: 0px;
  width: calc(100% - 240px) !important;
  left: 100px !important;
  top: 45px !important;

  .el-dialog__body {
    max-height: calc(100vh - 130px - 94px - 20px) !important;
    height: calc(100vh - 130px - 94px - 20px) !important;
  }
}

/deep/.dic-sub-table-style01 .el-table__row .cell {
  width: 100% !important;
}

/deep/.el-button--table-top-active {
  cursor: default;

  span {
    cursor: default;
  }
}

.packNameBox {
  font-size: 14px;
  margin: 0 0 20px 20px;
}

.packBox {
  display: flex;
  justify-content: space-between;
}

.address-cell {
  .linkBox {
    color: #0089ef;
    cursor: pointer;
    white-space: normal !important;
    /* 允许换行 */
    word-break: break-word;
    /* 在长单词或URL内部进行换行 */
    line-height: 25px;
  }
}
/* 为选中的列添加蓝色样式 */
/deep/ .el-table thead .active-column .cell {
  color: #0089ef !important;
  font-weight: bold;
}

.noneDataBox {
  width: 100%;
  text-align: center;
}
.sure-btn {
  margin-right: 0;
  border-color: #0089ef;
  color: #ffffff;
  background: #0099f1;
}
</style>
